import { render, staticRenderFns } from "./join-request-modal.vue?vue&type=template&id=590e5c07&scoped=true"
import script from "./join-request-modal.vue?vue&type=script&lang=js"
export * from "./join-request-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e5c07",
  null
  
)

export default component.exports